import { Loading, isSuccess } from "@dgs/core";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate, useParams } from "react-router";
import { eventService as sharedEventService } from "../../../shared/api/eventService";
import { calendarEventService } from "../../../shared/calendar/events/calendarEventService";
import { mapEventToFormValues } from "../../../shared/events/save/eventFormUtils";
import { UpdateEvent } from "../../../shared/events/save/UpdateEvent";
import { useFrontendConfig } from "../config/useFrontendConfig";
import { eventService } from "../shared/api/eventService";

export const UpdateEventPage: FC = () => {
	const { viewType = "", eventId = "" } = useParams<{ viewType: string; eventId: string }>();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { defaultCurrency } = useFrontendConfig();

	const { data: event, isLoading } = useQuery({
		queryKey: sharedEventService.showKey(eventId),
		queryFn: () => sharedEventService.show(eventId).then((x) => x.data.data),
	});

	if (isLoading || !event) {
		return <Loading />;
	}

	return (
		<UpdateEvent
			variant="outlined"
			initialValues={mapEventToFormValues(event, defaultCurrency)}
			onSubmit={async (request) => {
				const response = await sharedEventService.update(eventId, request);
				void queryClient.invalidateQueries({ queryKey: eventService.listOverviewKey });
				void queryClient.invalidateQueries({ queryKey: sharedEventService.showKey(eventId) });
				void queryClient.invalidateQueries({ queryKey: calendarEventService.calendarKey });
				void queryClient.invalidateQueries({ queryKey: eventService.detailsKey(eventId) });

				if (isSuccess(response)) {
					navigate(`/events/${viewType}/${eventId}`);
				}
			}}
		/>
	);
};
